import { type CompraAgil } from './api.schema';
import { type ListarComprasAgilesUi } from './ui.schema';

export { 
  ListarComprasAgilesResponseSchema,
  type ListarComprasAgilesResponse,
  type CompraAgil,
  type CompraAgilData,
  type JsonMetadataCompraAgil,
  type ArchivoCompraAgil,
  type PreguntaRespuestaCompraAgil
} from './api.schema';

export { 
  ListarComprasAgilesUiSchema,
  type ListarComprasAgilesUi 
} from './ui.schema';


export const transformComprasAgilesApiToUi = (comprasAgiles: CompraAgil[]): ListarComprasAgilesUi[] => {
  return comprasAgiles.map(item => ({
    id: item.data.id,
    nombre: item.data.nombre,
    resumen: item.data.resumen,
    codigo_externo: item.data.codigo_externo,
    codigo_estado: item.data.codigo_estado,
    estado_licitacion: item.data.estado_compra_agil, // Mapeo estado_compra_agil -> estado_licitacion
    fecha_creacion: item.data.fecha_creacion,
    fecha_cierre: item.data.fecha_cierre,
    archivos: item.archivos,
    visto: item.data.visto,
    postulado: item.data.postulado,
    fecha_postulacion: item.data.fecha_postulacion,
    adjudicado: item.data.adjudicado,
    fecha_adjudicacion: item.data.fecha_adjudicacion
  }));
}; 